import React, { useState, useEffect } from 'react';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/react';
import { ReactComponent as ClientesIcon } from '../../assets/icons/ClientesIcon.svg';
import { getAuth } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { formatearFechaInput, isoAFechaDisplay, fechaDisplayAIso } from '../../services/fechas';

const ClientesForm = ({ clienteParaEditar, onClose, onSuccess }) => {
const [personeria, setPersoneria] = useState(clienteParaEditar?.personeria || '');
const [isLoading, setIsLoading] = useState(false);
const navigate = useNavigate();
const [progress, setProgress] = useState(0);
const [formData, setFormData] = useState({
fechaDeNacimiento: isoAFechaDisplay(clienteParaEditar?.fechaDeNacimiento),
nombre: clienteParaEditar?.nombre || '',
apellido: clienteParaEditar?.apellido || '',
tipo: clienteParaEditar?.tipo || '',
numeroDeDocumento: clienteParaEditar?.numeroDeDocumento || '',
razonSocial: clienteParaEditar?.razonSocial || '',
cuit: clienteParaEditar?.cuit || '',
personaDeContacto: clienteParaEditar?.personaDeContacto || '',
calle: clienteParaEditar?.calle || '',
altura: clienteParaEditar?.altura || '',
piso: clienteParaEditar?.piso || '',
unidad: clienteParaEditar?.unidad || '',
codigoPostal: clienteParaEditar?.codigoPostal || '',
ciudad: clienteParaEditar?.ciudad || '',
pais: clienteParaEditar?.pais || '',
telefono: clienteParaEditar?.telefono || '',
correoElectronico: clienteParaEditar?.correoElectronico || '',
});
const [isFormValid, setIsFormValid] = useState(false);

const handlePersoneriaChange = (value) => {
setPersoneria(value);
if (value === 'persona fisica') {
setFormData(prevData => ({
...prevData,
razonSocial: '',
cuit: '',
personaDeContacto: '',
}));
} else {
setFormData(prevData => ({
...prevData,
nombre: '',
apellido: '',
tipo: '',
numeroDeDocumento: '',
}));
}
};
const handleChange = (e) => {
  const { name, value } = e.target;
  let formattedValue = value;

  const digitsOnly = value.replace(/\D/g, '');

  if (name === 'fechaDeNacimiento') {
    formattedValue = formatearFechaInput(value);
  } else if (name === 'numeroDeDocumento') {
    const tipo = formData.tipo;

    if (tipo === 'DNI') {
      if (!digitsOnly) {
        formattedValue = '';
      } else if (digitsOnly.length <= 2) {
        formattedValue = digitsOnly;
      } else if (digitsOnly.length <= 5) {
        formattedValue = `${digitsOnly.substring(0, digitsOnly.length - 3)}.${digitsOnly.substring(digitsOnly.length - 3)}`;
      } else {
        formattedValue = `${digitsOnly.substring(0, digitsOnly.length - 6)}.${digitsOnly.substring(digitsOnly.length - 6, digitsOnly.length - 3)}.${digitsOnly.substring(digitsOnly.length - 3)}`;
      }
    } else if (tipo === 'CUIT/CUIL') {
      const maxLen = 11;
      if (digitsOnly.length > maxLen) {
        return; 
      }
      if (digitsOnly.length <= 2) {
        formattedValue = digitsOnly;
      } else if (digitsOnly.length <= 10) {
        const prefix = digitsOnly.substring(0, 2);
        const middle = digitsOnly.substring(2, digitsOnly.length - 1);
        const suffix = digitsOnly.substring(digitsOnly.length - 1);
        formattedValue = `${prefix}-${middle}-${suffix}`;
      } else {
        const limited = digitsOnly.substring(0, 11);
        const prefix = limited.substring(0, 2);
        const middle = limited.substring(2, limited.length - 1);
        const suffix = limited.substring(limited.length - 1);
        formattedValue = `${prefix}-${middle}-${suffix}`;
      }
    } else {
      // Casos como 'Libreta Cívica', 'Pasaporte', etc.
      const maxLen = {
        'Libreta Cívica': 9,
        'Pasaporte': 10,
      };
      if (value.length > maxLen[tipo]) {
        return;
      }
      formattedValue = value;
    }

  } else if (name === 'cuit') {
    const maxLen = 11;
    if (digitsOnly.length > maxLen) {
      return;
    }
    if (digitsOnly.length <= 2) {
      formattedValue = digitsOnly;
    } else if (digitsOnly.length <= 10) {
      const prefix = digitsOnly.substring(0, 2);
      const middle = digitsOnly.substring(2, digitsOnly.length - 1);
      const suffix = digitsOnly.substring(digitsOnly.length - 1);
      formattedValue = `${prefix}-${middle}-${suffix}`;
    } else {
      const limited = digitsOnly.substring(0, 11);
      const prefix = limited.substring(0, 2);
      const middle = limited.substring(2, limited.length - 1);
      const suffix = limited.substring(limited.length - 1);
      formattedValue = `${prefix}-${middle}-${suffix}`;
    }
  }

  setFormData({
    ...formData,
    [name]: formattedValue,
  });
};

const handleSubmit = async (e) => {
e.preventDefault();

let fechaDeNacimientoIso = '';
if (formData.fechaDeNacimiento) {
fechaDeNacimientoIso = fechaDisplayAIso(formData.fechaDeNacimiento);
if (!fechaDeNacimientoIso) {
alert('Fecha de nacimiento no es una fecha válida. Usá el formato dd/mm/aaaa.');
return;
}
}

setIsLoading(true);
setProgress(0);

const user = getAuth().currentUser;
if (!user) {
setIsLoading(false);
return;
}

let datosParaEnviar = { ...formData, fechaDeNacimiento: fechaDeNacimientoIso, personeria };

if (personeria === 'persona fisica') {
    if (datosParaEnviar.tipo === 'DNI' || datosParaEnviar.tipo === 'CUIT/CUIL') {
        datosParaEnviar.numeroDeDocumento = datosParaEnviar.numeroDeDocumento.replace(/\D/g, '');
    }
} else if (personeria === 'persona juridica') {
    datosParaEnviar.cuit = datosParaEnviar.cuit.replace(/\D/g, '');
}

try {
const idToken = await user.getIdToken();

let url, method;
if (clienteParaEditar) {
const idLimpio = clienteParaEditar.id.replace(/[-.]/g, '');
url = `https://backend-288175208699.europe-west1.run.app/editar-cliente/${idLimpio}`;
method = "PUT";
} else {
url = "https://backend-288175208699.europe-west1.run.app/crear-cliente";
method = "POST";
}

// Simulación de progreso
let fakeProgress = 0;
const interval = setInterval(() => {
fakeProgress += 10;
setProgress(fakeProgress);
if (fakeProgress >= 90) clearInterval(interval); // queda esperando la respuesta
}, 200);

const res = await fetch(url, {
method,
headers: {
"Content-Type": "application/json",
Authorization: `Bearer ${idToken}`,
},
body: JSON.stringify(datosParaEnviar),
});

const data = await res.json();
if (!res.ok) throw new Error(data.error || "Error en la operación");

clearInterval(interval); // detiene la simulación de progreso
setProgress(100);
if (!clienteParaEditar && data.cliente_id) {
// Si estamos creando un nuevo cliente y el backend nos devolvió el ID, navegamos.
navigate(`/clientes/${data.cliente_id}`); 
}
onSuccess?.();
onClose?.();
} catch (err) {
alert(err.message);
} finally {
setIsLoading(false);
setTimeout(() => setProgress(0), 500); // reinicia
}
};

useEffect(() => {
    if (clienteParaEditar) {
        setIsFormValid(personeria !== '');
        return;
    }

    let isValid = false;
    
    // Validamos que haya al menos un medio de contacto
    const tieneContacto = formData.correoElectronico.trim() !== '' || formData.telefono.trim() !== '';

    if (personeria === 'persona fisica') {
        const requiredPFFields = ['nombre', 'apellido', 'tipo', 'numeroDeDocumento'];
        const allPFFieldsFilled = requiredPFFields.every(field => formData[field].trim() !== '');
        
        isValid = allPFFieldsFilled && tieneContacto;
        
    } else if (personeria === 'persona juridica') {
        const requiredPJFields = ['razonSocial', 'cuit'];
        const allPJFieldsFilled = requiredPJFields.every(field => formData[field].trim() !== '');
        
        isValid = allPJFieldsFilled && tieneContacto;
    }

    setIsFormValid(isValid);
}, [formData, personeria, clienteParaEditar]);

const personeriaOptions = [
{ value: 'persona fisica', label: 'Persona física' },
{ value: 'persona juridica', label: 'Persona jurídica' },
];

// Se añade el nuevo tipo de documento
const tipoDocumentoOptions = [
{ value: 'DNI', label: 'DNI' },
{ value: 'CUIT/CUIL', label: 'CUIT/CUIL' },
{ value: 'Pasaporte', label: 'Pasaporte' },
{ value: 'Libreta Cívica', label: 'Libreta Cívica' },
];

return (
<div style={{ padding: '0 16px',overflow:'hidden',height:'100%' }}>
<header className="trazabilidad-header">
<div className="header-content">
<h1>Clientes</h1>
</div>
</header>
<div className="container" style={{ margin: '0 10px' }}>
<div className="formtitle-container">
<div className="formicon-container">
<ClientesIcon className="formicon" style={{ height: '20px', margin: 'auto' }} />
</div>
<h1 className="formtitle">Alta de cliente</h1>
{clienteParaEditar && (<div className='remove-button' onClick={onClose} style={{ margin: '0 0 0 auto' }}>&times;</div>)}
</div>
<hr className="divider" />
<form onSubmit={handleSubmit} className="form" style={{ width: '40%' }}>
<div className="columns-container">
<div className="column long">
<div className="input-group">
<Listbox value={personeria} onChange={handlePersoneriaChange}>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${!personeria ? 'placeholder' : ''}`}>
{personeriaOptions.find(opt => opt.value === personeria)?.label || "Personería"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{personeriaOptions.map((option) => (
<ListboxOption key={option.value} value={option.value} className="custom-listbox-option">
{option.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
{personeria && (
<>
{personeria === 'persona fisica' && (
<>
<div className="input-group">
<input type="text" name="nombre" value={formData.nombre} onChange={handleChange} placeholder="Nombre" required className="input" />
</div>
<div className="input-group">
<input type="text" name="apellido" value={formData.apellido} onChange={handleChange} placeholder="Apellido" required className="input" />
</div>
<label className='data-label'>Fecha de nacimiento</label>
<div className="input-group">
<input
type="text"
inputMode="numeric"
name="fechaDeNacimiento"
value={formData.fechaDeNacimiento}
onChange={handleChange}
placeholder="dd/mm/aaaa"
className="input"
/>
</div>
<label className='data-label'>TIPO Y NÚMERO DE DOCUMENTO</label>
<div style={{ display: 'flex', width: '100%', gap: '10px' }}>
<div className="input-group">
<Listbox
value={formData.tipo}
onChange={(value) => handleChange({ target: { name: 'tipo', value } })}
>
{({ open }) => (
<>
<ListboxButton style={{ width: '150px' }} className={`custom-listbox-button ${open ? 'open' : ''} ${!formData.tipo ? 'placeholder' : ''}`}>
{formData.tipo || "Tipo"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options" style={{ top: '31px' }}>
{tipoDocumentoOptions.map((option) => (
<ListboxOption key={option.value} value={option.value} className="custom-listbox-option" >
{option.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<input type="text" name="numeroDeDocumento" value={formData.numeroDeDocumento} onChange={handleChange} placeholder="Número" required className="input-address" style={{ width: '75%', textAlign: 'left' }} />
</div>
</>
)}
{personeria === 'persona juridica' && (
<>
<div className="input-group">
<input type="text" name="razonSocial" value={formData.razonSocial} onChange={handleChange} placeholder="Razón Social" required className="input" />
</div>
<div className="input-group">
<input type="text" name="cuit" value={formData.cuit} onChange={handleChange} placeholder="CUIT" required className="input" />
</div>
</>
)}
<span className="data-label">Domicilio de residencia</span>
<div className="input-group">
<input
type="text"
name="calle"
placeholder="Calle"
value={formData.calle}
onChange={handleChange}
className="input"
/>
</div>
<div style={{ display: 'flex', width: '100%', gap: '10px' }}>
<input
type="text"
name="altura"
placeholder="Altura"
value={formData.altura}
onChange={handleChange}
className="input-address"
/>
<input
type="text"
name="piso"
placeholder="Piso"
value={formData.piso}
onChange={handleChange}
className="input-address"
/>
<input
type="text"
name="unidad"
placeholder="Unidad"
value={formData.unidad}
onChange={handleChange}
className="input-address"
/>
<input
type="text"
name="codigoPostal"
placeholder="CP"
value={formData.codigoPostal}
onChange={handleChange}
className="input-address"
/>
</div>
<div className="input-group">
<input
type="text"
name="ciudad"
placeholder="Ciudad / Localidad / Provincia"
value={formData.ciudad}
onChange={handleChange}
className="input"
/>
</div>
<div className="input-group">
<input
type="text"
name="pais"
placeholder="País"
value={formData.pais}
onChange={handleChange}
className="input"
/>
</div>
{personeria === 'persona juridica' && (
<>
<div className="input-group">
<input 
type="text" 
name="personaDeContacto" 
value={formData.personaDeContacto} 
onChange={handleChange} 
placeholder="Persona de contacto"
className="input" 
/>
</div>
</>
)}
<div className="input-group">
<input type="tel" name="telefono" value={formData.telefono} onChange={handleChange} placeholder="Teléfono" className="input" />
</div>
<div className="input-group">
<input type="email" name="correoElectronico" value={formData.correoElectronico} onChange={handleChange} placeholder="Correo electrónico" className="input" />
</div>
<div className="button-container" >
<hr style={{ border: "0", borderTop: "1px solid #eaeef5", margin: "0px 0 0px" }} />
<button
type="submit"
className="button"
disabled={!isFormValid || isLoading}
style={{ width: clienteParaEditar ? '175px' : '130px' }}
>
<span className="button-text">{clienteParaEditar ? "Guardar cambios" : "Dar de alta"}</span>
{isLoading && (
<span className="progress-bar" style={{ width: `${progress}%` }}></span>
)}
</button>
</div>
</>
)}
</div>
</div>
</form>
</div>
</div>
);
};

export default ClientesForm;